const UPDATE_HELPDESK_LIST = "UPDATE_HELPDESK_LIST";
const UPDATE_HELPDESK_ASSIGNEE_LIST = "UPDATE_HELPDESK_ASSIGNEE_LIST";

export interface IAttachedFile {
    id?: number;
    fileName: string;
    content: string;
    createdAt?: "";
}

export interface IComment {
    id?: number;
    message: string;
    attachedFiles?: IAttachedFile[];
    createdAt?: string;
}

export interface IAssigneeList {
    id?: number;
    step: string;
    status: string;
    comments?: IComment[];
    createdAt?: string;
    assignee?: string;
}

export interface IHelpdeskCreateRequest {
    id?: number;
    category: string;
    type?: string;
    categoryDescription: string;
    assigneeRoles?: string[];
    requestType: string;
    description: string;
    initiator?: string;
    assignee?: string;
    status: string;
    priority: string;
    assigneeLists: IAssigneeList[];
    createdAt: "";
    ticketId?: number;
}
/**
 * Заявки из очереди по роли, которые можно показывать в «К исполнению»:
 * свободные (без ответственного) и те, что висят на текущем пользователе.
 * Бэк отдаёт по роли и заявки, уже взятые в работу другим сотрудником, — их скрываем.
 * Ответственным может стоять не логин, а код роли (заявку вернули в очередь) —
 * такая заявка считается свободной.
 */
export const filterFreeOrOwnTickets = (
    tickets: IHelpdeskCreateRequest[],
    userLogin: string,
    roleCodes: string[] = [],
): IHelpdeskCreateRequest[] =>
    (tickets || []).filter((ticket) => {
        const assignee = ticket.assignee;
        if (!assignee || assignee === userLogin) return true;
        return roleCodes.includes(assignee) || !!ticket.assigneeRoles?.includes(assignee);
    });

export interface HDReducer {
    hdList: IHelpdeskCreateRequest[];
    hdAssigneeList: IHelpdeskCreateRequest[];
    helpdesk?: IHelpdeskCreateRequest;
}

const initialState: HDReducer = {
    hdList: [],
    hdAssigneeList: [],
};

export default function helpdesk(state = initialState, action: HelpdeskAction) {
    let _state = state;
    switch (action.type) {
        case UPDATE_HELPDESK_LIST:
            return {
                ...state,
                hdList: action.payload,
            };
        case UPDATE_HELPDESK_ASSIGNEE_LIST:
            return {
                ...state,
                hdAssigneeList: action.payload,
            };
        default:
            _state = state;
            break;
    }

    return _state;
}

type HelpdeskAction =
    | ReturnType<typeof helpdeskList>
    | ReturnType<typeof helpdeskAssigneeList>;

const helpdeskList = (payload: IHelpdeskCreateRequest[]) => ({
    type: UPDATE_HELPDESK_LIST as typeof UPDATE_HELPDESK_LIST,
    payload,
});
const helpdeskAssigneeList = (payload: IHelpdeskCreateRequest[]) => ({
    type: UPDATE_HELPDESK_ASSIGNEE_LIST as typeof UPDATE_HELPDESK_ASSIGNEE_LIST,
    payload,
});

export const actions = {
    helpdeskList,
    helpdeskAssigneeList,
};